<h3 mat-dialog-title>Opening Size Calculator</h3>

<mat-dialog-content>
  Artwork Size:

  <div class="flex-center">
    <div class="select-wrapper">
      <mbnm-lazy-size-select [range]="widthRange" [(ngModel)]="artwork.width">
      </mbnm-lazy-size-select>
    </div>

    <div class="x">
      x
    </div>

    <div class="select-wrapper">
      <mbnm-lazy-size-select [range]="heightRange" [(ngModel)]="artwork.height">
      </mbnm-lazy-size-select>
    </div>
  </div>

  Opening Size:

  <div class="opening-size" [ngClass]="{incomplete: opening.incomplete}">{{ opening.incomplete ? 'choose artwork size' : opening.toString() }}</div>
</mat-dialog-content>

<mat-dialog-actions>
  <!--
  <button mat-flat-button color="primary" mat-dialog-close="keep">See <strong>{{ data.selection | stringFormat:data.selection.format}}</strong> {{ data.productName }}</button>
  -->
  <button mat-flat-button color="primary" [mat-dialog-close]="opening">
    Set Opening Size
  </button>

  <button mat-flat-button color="secondary" mat-dialog-close>
    Cancel
  </button>

</mat-dialog-actions>
